export  const UNBCNFTContractAddress = '0xEDa45366e9135920403A15Dc697b021f80Ff9d2D'
export  const minterContractAddress = '0xE68E94011CdB743B75a086afe8304BF8b72d8226'
export  const settingContractAddress = '0xc570dA3333f5eD1ae672f9926C78B038952714F9'
export  const utopiaFactoryContractAddress   = '0xFcdF8f39CFe0a928081cC8C4D0eF3f6E2CE5452E'